import { PatientsService } from "@/common/api.service";
import { FETCH_PATIENT_DATA, FETCH_INDIVIDUAL_PATIENT_DATA, FETCH_PATIENT_ALERTS_HISTORY_DATA, UPDATE_PATIENT_DATA, CREATE_PATIENT_DATA, RESET_STATE } from "./actions.type";
import { SET_PATIENT_DATA, SET_INDIVIDUAL_PATIENT_DATA, SET_PATIENT_ERROR, SET_PATIENT_ALERTS_HISTORY_DATA, STATE_RESET } from "./mutations.type";


function parseMonthDate(val) {
  if (val < 10) {
    return `0${val}`
  }
  return val
}

const initialState = () => {
  return {
    patientdata: [],
    individualpatientdata: [],
    patientserror: [],
    patientalertshistorydata: []
  }
};

export const state = initialState();

const actions = {

  async [FETCH_PATIENT_DATA](context, slug) {
    return await PatientsService.create(slug.url, slug.params).then((response) => {
      context.commit(SET_PATIENT_DATA, response.data)
      return response
    }).catch(({ response }) =>{
      context.commit(SET_PATIENT_ERROR, response.data.errorMessage)
      return response
    })
  },

  async [FETCH_INDIVIDUAL_PATIENT_DATA](context, slug) {
    return await PatientsService.get(slug).then((response) => {
      context.commit(SET_INDIVIDUAL_PATIENT_DATA, response.data)
      return response
    }).catch(({ response })=>{
      context.commit(SET_PATIENT_ERROR, response.data.errorMessage)
      return response
    })
  },

  async [FETCH_PATIENT_ALERTS_HISTORY_DATA](context, slug) {
    return await PatientsService.get(slug).then((response) => {
      context.commit(SET_PATIENT_ALERTS_HISTORY_DATA, response.data)
      return response
    }).catch(({ response })=>{
      context.commit(SET_PATIENT_ERROR, response.data.errorMessage)
      return response
    })
  },

  async [CREATE_PATIENT_DATA](context, slug) {
    return await PatientsService.create(slug.slug, slug.params).then((response) => {
      return response
    }).catch(({ response})=>{
      context.commit(SET_PATIENT_ERROR, response.data.errorMessage)
      return response
    })
  },

  async [UPDATE_PATIENT_DATA](context, slug) {
    return await PatientsService.update(slug.slug, slug.params).then((response) => {
      return response
    }).catch(({ response }) => {
      context.commit(SET_PATIENT_ERROR, response.data.errorMessage)
      return response
    })
  },

  [RESET_STATE]({ commit }) {
    commit(STATE_RESET)
  }

}

const mutations = {

  [SET_PATIENT_DATA](state, patientdata) {
    state.patientdata = patientdata
  },
  [SET_PATIENT_ALERTS_HISTORY_DATA](state,patientalertshistorydata) {
    state.patientalertshistorydata = patientalertshistorydata
  },
  [SET_INDIVIDUAL_PATIENT_DATA](state, individualpatient) {
    const data = JSON.parse(JSON.stringify(individualpatient));
    const keys = Object.keys(data);
    if (keys.includes('education') && Array.isArray(data.education)) {
      const educationData = data.education;
      for (let i = 0; i < educationData.length; i++) {
        if (Array.isArray(educationData[i].date)) {
          educationData[i].date = educationData[i].date.join('-')
        }
      }
    }
    if (keys.includes('surveys') && Array.isArray(data.surveys)) {
      const surveysData = data.surveys;
      for (let i = 0; i < surveysData.length; i++) {
        if (Array.isArray(surveysData[i].assignedDate)) {
          surveysData[i].assignedDate = surveysData[i].assignedDate.join('-')
        }
        if (Array.isArray(surveysData[i].expirationDate)) {
          surveysData[i].expirationDate = surveysData[i].expirationDate.join('-')
        }
        if (Array.isArray(surveysData[i].nextScheduledDate)) {
          surveysData[i].nextScheduledDate = surveysData[i].nextScheduledDate.join('-')
        }
        if (Array.isArray(surveysData[i].alertTime)) {
          surveysData[i].alertTime = `${parseMonthDate(Number(surveysData[i].alertTime[0]))}:${parseMonthDate(Number(surveysData[i].alertTime[1]))}`
        }
        const responseData = surveysData[i].response;
        if (Array.isArray(responseData)) {
          for (let j = 0; j < responseData.length; j++) {
            if (Array.isArray(responseData[j].responseDate)) {
              surveysData[i].response[j].responseDate = surveysData[i].response[j].responseDate.join('-')
            }
          }
        }
      }
    }
    
    if (keys.includes('onboardingDate') && Array.isArray(data.onboardingDate)) {
      data.onboardingDate = `${data.onboardingDate[0]}-${parseMonthDate(Number(data.onboardingDate[1]))}-${parseMonthDate(Number(data.onboardingDate[2]))}`
    }

    state.individualpatientdata = data;
  },
  [SET_PATIENT_ERROR](state, error) {
    state.patienterror = error
  },
  [STATE_RESET](state) {
    Object.assign(state, initialState())
  }

}

const getters = {
  patientdata(state) {
    return state.patientdata;
  },
  individualpatientdata(state) {
    return state.individualpatientdata;
  },
  patientalertshistorydata(state) {
    return state.patientalertshistorydata;
  }

}

export default {
  state,
  getters,
  actions,
  mutations
};